import React, { useEffect, useState } from "react";
import DetailHeader from "../DetailsHeader/DetailHeader";
import Styles from "./Transactions.module.css";
import { useSelector } from "react-redux";
import { walletTransactionApi } from "../../../Services/Payments/PaymentApi";
import { getWalletAccountActivity } from "../../../Services/GNA/GetData";
import LoadMorePagination from "../../LoadeMore";
import { convertDate } from "../../../commons/FormatDate";

const Transactions = ({ walletId: walletIdProp }) => {
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const activeWalletId = walletIdProp || wallet?.id;

  useEffect(() => {
    setPage(0);
    setTransactions([]);
  }, [activeWalletId]);

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = walletIdProp
          ? await getWalletAccountActivity({
              walletId: walletIdProp,
              currentPage: page,
              size: 20,
            })
          : await walletTransactionApi({ page, size: 20 });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setTransactions((prev) =>
            page === 0 ? newData : [...prev, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
        } else {
          if (page === 0) setTransactions([]);
          setHasMore(false);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching transactions:", error);
        if (mounted && page === 0) setTransactions([]);
        if (mounted) setHasMore(false);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [page, walletIdProp, wallet?.id]);

  const handleLoadMore = () => setPage((prev) => prev + 1);

  const handleSelect = () => {};

  function formatDateTime(dateTimeStr) {
    if (!dateTimeStr) return "";

    const [datePart, timePart] = dateTimeStr.split(" ");
    const [day, month, year] = datePart.split("-");

    const date = new Date(`${year}-${month}-${day}T${timePart}`);

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <DetailHeader
        heading={"Transactions"}
        handleSelect={handleSelect}
        list={
          [
            // { name: "All", value: "all", status: true },
            // { name: "Ongoing", value: "ongoing", status: false },
            // { name: "Completed", value: "completed", status: false },
            // { name: "Pending", value: "pending", status: false },
          ]
        }
      />
      <div className={Styles.transactionTableWrapper}>
        {/* HEADER */}
        <div className={Styles.transactionTableHeader}>
          <div className={Styles.transactionColLg}>Self Listing</div>

          <div className={Styles.transactionColLg}>Counterparty Name</div>

          <div className={Styles.transactionColLg}>Contract Id</div>

          <div className={Styles.transactionColLg}>Transaction Date</div>

          <div className={Styles.transactionColLg}>Transaction Amount (₹)</div>

          <div className={Styles.transactionColSm}>Type</div>

          <div className={Styles.transactionAction}>Action</div>
        </div>

        {/* BODY */}
        <div className={Styles.transactionTableBody}>
          <LoadMorePagination
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            loading={loading}
          >
            {transactions?.map((ele, index) => (
              <div key={ele?.id ?? index} className={Styles.transactionRow}>
                {/* SELF LISTING */}
                <div className={Styles.transactionColLg}>
                  <div className={Styles.transactionPrimaryText}>
                    {ele?.listingId?.split("_")?.[0] || "-"}
                  </div>
                </div>

                {/* COUNTERPARTY */}
                <div className={Styles.transactionColLg}>
                  <div className={Styles.transactionPrimaryText}>
                    {(ele?.counterPartyName === "UNKNOWN"
                      ? ""
                      : ele?.counterPartyName) || "Not Generated"}
                  </div>

                  {ele?.counterPartyListingId && (
                    <div className={Styles.transactionSecondaryText}>
                      {ele?.counterPartyListingId || "-"}
                    </div>
                  )}
                </div>

                {/* CONTRACT ID */}
                <div className={Styles.transactionColLg}>
                  <div className={Styles.transactionPrimaryText}>
                    {ele?.bilateralContractUniqueId || "Not Generated"}
                  </div>
                </div>

                {/* DATE */}
                <div className={Styles.transactionColLg}>
                  <div className={Styles.transactionPrimaryText}>
                    {convertDate(ele?.dateTime?.split(" ")?.[0])}
                  </div>

                  <div className={Styles.transactionSecondaryText}>
                    {ele?.dateTime?.split(" ")?.[1]}
                  </div>
                </div>

                {/* AMOUNT */}
                <div className={Styles.transactionColLg}>
                  <div className={Styles.transactionAmount}>
                    ₹ {ele?.amount?.toFixed(2)}
                  </div>
                </div>

                {/* TYPE */}
                <div className={Styles.transactionColSm}>
                  <div className={Styles.transactionType}>
                    {ele?.paymentType?.split("_")?.join(" ") || "-"}
                  </div>
                </div>

                {/* ACTION */}
                <div className={Styles.transactionAction}>
                  <div
                    className={`${Styles.transactionStatus} ${
                      ele?.activity === "CREDIT" || ele?.activity === "RELEASED"
                        ? Styles.transactionSuccess
                        : Styles.transactionDanger
                    }`}
                  >
                    {ele?.activity}
                  </div>
                </div>
              </div>
            ))}
          </LoadMorePagination>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
